import React, { Component } from 'react';
import { Container, Card, Image, Button, Message, Statistic } from 'semantic-ui-react';
import moment from 'moment';
import StepGroup from './StepGroup.js';

class ToUserCard extends Component {
  render() {
    let paymentInfo, selection;
    if (this.props.status === 'wait') {
      paymentInfo = <Image fluid src={"https://chart.googleapis.com/chart?cht=qr&chs=220x220&chl=https%3A%2F%2Fqr.alipay.hk%2F"+this.props.alipay} />
      selection = <Button.Group fluid>
        <Button positive onClick={this.props.onClickScanPayment}>掃瞄</Button>
      </Button.Group>
    }
    if (this.props.status === 'scan') {
      paymentInfo = <Message>{this.props.alipayName}</Message>
      selection = <Button.Group fluid>
        <Button positive onClick={this.props.onClickConfirmPayment}>完成</Button>
        <Button negative onClick={this.props.onClickCancelPayment}>取消</Button>
      </Button.Group>
    }
    return (
      <Card fluid>
        <Card.Content>
          <Image floated='right' size='mini' src={this.props.imageSrc} />
          <Card.Header>{this.props.header}</Card.Header>
          <Card.Meta>{moment(this.props.createDate).format('YYYY-MM-DD')}</Card.Meta>
          <Card.Description>
            {paymentInfo}
            <Container textAlign='center'>
              <Statistic>
                <Statistic.Value>{this.props.amount}</Statistic.Value>
                <Statistic.Label>{this.props.method}</Statistic.Label>
              </Statistic>
            </Container>
            {selection}
          </Card.Description>
        </Card.Content>
        <Card.Content extra>
          <StepGroup status={this.props.status} />
        </Card.Content>
      </Card>
    )
  }
}

export default ToUserCard;



// WEBPACK FOOTER //
// ./src/ToUserCard.js